import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import ResetPassword from "@/pages/ResetPassword";
import AthletePortal from "@/pages/AthletePortal";
import AdminLayout from "@/pages/admin/AdminLayout";
import { Loader2 } from "lucide-react";

const FullLoader = () => (
  <div className="min-h-screen flex items-center justify-center bg-ink">
    <Loader2 className="w-8 h-8 text-brand animate-spin" />
  </div>
);

const Protected = ({ roles, children }) => {
  const { user, loading } = useAuth();
  if (loading) return <FullLoader />;
  if (!user) return <Navigate to="/login" replace />;
  if (roles && !roles.includes(user.role))
    return <Navigate to={user.role === "RUNNER" ? "/portal" : "/admin"} replace />;
  return children;
};

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/login" element={<Login />} />
          <Route path="/redefinir-senha" element={<ResetPassword />} />
          <Route
            path="/portal"
            element={
              <Protected roles={["RUNNER"]}>
                <AthletePortal />
              </Protected>
            }
          />
          <Route
            path="/admin/*"
            element={
              <Protected roles={["SUPER_ADMIN", "ADMIN_STAFF"]}>
                <AdminLayout />
              </Protected>
            }
          />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" richColors theme="dark" />
    </AuthProvider>
  );
}

export default App;
